import { legacyApiAuth } from '../../../apis/legacies-api/legacy-api'
import { convertSnakeCaseToCamelCase } from '@wiggot/web-components/utils/formatterResponse'
import {
  defaultApiBasic,
  defaultApiBasicX
} from '../../../apis/new-apis/default-api'
import {
  ICustomDatasheet,
  IPostCustomDatasheetData,
  IPropertyLead,
  IPropertyLeadBody,
  IPropertyLeadParams,
  IResponseService
} from '../interfaces/service-interface'
import { wiggotAPI } from '../../../apis/legacies-api/wiggot-api'

export const PostCustomDatasheet = async ({
  propertyIds,
  customImagesId,
  customTitle,
  customDescription,
  customCoverImage
}: ICustomDatasheet): Promise<IResponseService<{ datasheetId: string }>> => {
  const response = await legacyApiAuth.post<
    { datasheet_id: string },
    IPostCustomDatasheetData
  >(`/v2.0.2/datasheet/share_custom`, {
    property_id: propertyIds,
    custom_images_id: customImagesId,
    custom_title: customTitle,
    custom_description: customDescription,
    custom_cover_image: customCoverImage
  })
  try {
    return {
      isSuccess: true,
      data: convertSnakeCaseToCamelCase(response)
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const propertyLead = async ({
  propertyId,
  wiggotUserId,
  name,
  email,
  phone,
  message,
  phoneCode,
  incomingUrl,
  source,
  isBroker = true,
  profileId
}: IPropertyLeadParams): Promise<IResponseService<IPropertyLead[]>> => {
  try {
    const phoneNumber =
      phone?.length > 10 ? phone.slice(phone?.length - 10) : phone

    const response = await defaultApiBasic.post<
      IPropertyLead[],
      IPropertyLeadBody
    >(`/lead-management/leads`, {
      wiggotUserId,
      propertyId,
      email,
      incomingUrl,
      message,
      name,
      phone: phoneNumber,
      source,
      phoneCode,
      isBroker,
      profileId
    })

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export interface IConfigPdf {
  showAdvisorData: boolean
  showCommission: boolean
  showCreditSimulation: boolean
  profileId?: string
}
export const getConfigPdf = async (
  reference: string
): Promise<IResponseService<IConfigPdf>> => {
  try {
    const response = await wiggotAPI.get<IResponseService<IConfigPdf>>(
      `/share/property/config/reference/${reference}`
    )
    return {
      isSuccess: true,
      data: response.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

interface IPropertyInteractionProps {
  link: string
  propertyLegacyIds: string[]
  userId: string
  type: string
  userData?: {
    [key: string]: string
  }
}

interface IPropertyInteraction {
  propertyLegacyIds: string[]
  interactionType: string
  data?: IPropertyInteractionProps
  metadata: {
    link: string
    userData?: {
      [key: string]: string
    }
  }
  source: string
  userId: string
}

export const propertyInteraction = async ({
  propertyLegacyIds,
  link,
  userId,
  type,
  userData
}: IPropertyInteractionProps): Promise<
  IResponseService<IPropertyInteractionProps>
> => {
  try {
    const response = await defaultApiBasicX.post<
      IPropertyInteraction,
      IPropertyInteraction
    >(`lead-management/interaction/property`, {
      propertyLegacyIds,
      interactionType: type,
      metadata: {
        link,
        userData
      },
      source: 'WIGGOT_PUBLIC_DATA_SHEET',
      userId: userId?.toString() || ''
    })

    return {
      isSuccess: true,
      data: response?.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
